module.exports = __webpack_public_path__ + "img/quizActive.0c1e2b09.png";